export const isMobile = () => window.matchMedia('(max-width: 576px)').matches